import { Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { worksheetRoutes } from './Worksheet';
import Worksheet from 'pages/Business/Agent/Worksheet';

import Spinner from 'components/Common/Spinner';

export default function WorksheetRoutes() {
  return (
    <Suspense fallback={<Spinner />}>
      <Routes>
        <Route index={true} element={<Worksheet />} />
        {worksheetRoutes}
        <Route path='*' element={<Navigate to='/404' replace />} />
      </Routes>
    </Suspense>
  );
}
